import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { PostEdit, Post, Discard } from "../../../Constant";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import HeaderCard from "../../Common/HeaderCard";
import FormPost from "./FormPost";
import DropzoneClass from "./DropzoneClass";

const BlogPostContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle="Add Post" parent="Blog" title="Add Post" />
      <Row>
        <Col sm="12">
          <Card>
            <HeaderCard title={PostEdit} />
            <CardBody className="add-post">
              <FormPost />
              <DropzoneClass />
              <div className="btn-showcase">
                <Btn color="primary" type="submit">
                  {Post}
                </Btn>
                <Btn color="light" type="reset">
                  {Discard}
                </Btn>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BlogPostContainer;
